

export type LabelValue<T = string> = { label: string, value: T };
export const LabelValue = Object.assign(
    <T extends unknown>(label: string, value: T): LabelValue<T> => ({ label, value }),
    {
        fromRecord<T>(obj: Record<string, T>) {
            return Object.entries(obj).map(x => LabelValue<T>(x[0], x[1]));
        },
        fromMap<T>(map: Map<string, T>) {
            return Array.from(map.entries()).map(x => LabelValue<T>(x[0], x[1]));
        },
    }
);